var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.093a779e1b15706f53b2759ff7724309.svg#r';
                    var viewUrl = 'sprites.093a779e1b15706f53b2759ff7724309.svg#view-r';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 15 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };